{
    "aboutbanner.label": "{siloName} Ils spazis èn differents",
    "account.admin_email_notifications": "Notifitgas per e-mail da l’administraziun",
    "account.admin_language": "Lingua preferida",
    "account.admin_language_no_language": "Nagina lingua",
    "account.admin_moderation_dash_settings": "Configuraziuns dal dashboard da moderaziun",
    "account.email_notifications": "Notifications per e-mail",
    "account.notification.email.moderationdecisions": "Decisiuns da moderaziun",
    "account.notification.email.replies": "Respostas",
    "account.title": "Account",
    "account.warnings_and_blocks": "Admoniziuns e bloccas",
    "account_delete.confirm_description": "Stizzar Voss profil na po betg vegnir revocà. I po cuzzar fin 72 uras da stizzar tut las datas e tut las activitads ch'èn colliadas cun Voss profil.",
    "account_delete.confirm_heading": "Essas Vus segir:a che Vus vulais stizzar Vossas datas da profil?",
    "account_delete.description": "Sin giavisch vegnan stizzads il decurs da la discussiun da Voss conto e Vossas contribuziuns. Quest proceder è irrevocabel.",
    "account_delete.heading": "Stizzar mias datas",
    "account_request_data.heading": "Dumandar si mias datas",
    "account_request_data.instructions": "Tramettai in e-mail a [privacy@newpublic.org](mailto:privacy@newpublic.org) per dumandar ina copia da Vossas datas colliadas cun quest sectur da discussiun. L'elavuraziun da Vossa dumonda po durar fin a 30 dis.",
    "account_revoke_permissions.confirm_heading": "Revocar ils dretgs d'admin da {identifier}?",
    "account_revoke_permissions.confirm_text": "{identifier} na vegn betg pli ad avair dretgs d'admin.",
    "account_revoke_permissions.revoke_button": "Revocar ils dretgs",
    "action.block": "Bloccar",
    "action.cancel": "Annullar",
    "action.create_new_voting": "Crear ina nova votaziun",
    "action.delete": "Stizzar",
    "action.edit": "Modifitgar",
    "action.open_teaser_positioning": "Avrir la posiziun da teaser",
    "action.pinned": "Fixà",
    "action.post": "Contribuir",
    "action.reply_to_user": "Respunder a {userName}",
    "action.report": "Rapportar",
    "action.save": "Arcunar",
    "action.unblock": "Debloccar",
    "admin.category_analysis_heading": "Analisa",
    "admin.category_developer_tools_heading": "Dev tools",
    "admin.category_editorial_heading": "Redacziunal",
    "admin.category_moderation_heading": "Moderaziun",
    "admin.category_owner_tools_heading": "Owner tools",
    "admin.category_starred_heading": "Marcà",
    "admin.window_title": "Dashboard d'admin",
    "admin_mod_link.admin_users_description": "Administraziun dals dretgs dals utilisaders.",
    "admin_mod_link.developer_tools_label": "Utensils per sviluppaders",
    "admin_mod_link.editorial_dashboard_description": "Administrar secturs e dapli.",
    "admin_mod_link.editorial_dashboard_label": "Dashboard redacziunal",
    "admin_mod_link.moderation_dashboard_description": "Moderaziun da discussiuns en il dashboard nov (WIP)",
    "admin_mod_link.moderation_dashboard_label": "Dashboard da moderaziun",
    "admin_mod_link.ranking_eval_description": "Valitar differents algoritms da rangaziun davart conversaziuns realas.",
    "admin_mod_link.ranking_eval_label": "Valitaziun da la rangaziun",
    "admin_mod_link.settings_description": "Administrar configuraziuns e funcziuns da l'organisaziun.",
    "admin_mod_link.settings_label": "Configuraziun",
    "admin_mod_link.storybook_description": "Vesair cumponentas da PSI en Storybook.",
    "admin_mod_link.storybook_label": "Storybook",
    "admin_users.add_admins_button": "Agiuntar adminis",
    "admin_users.add_new_admins_label": "Agiuntar nov:as administratur:as",
    "admin_users.adding_admins_message": "Admins vegnan agiuntad:as…",
    "admin_users.deprecated_role_notice": "Obsolet: {deprecatedRoles}. Midar ad ina da {currentRoles}.",
    "admin_users.deprecated_roles_heading": "Rollas deprecadas",
    "admin_users.deprecated_roles_hint": "Questas rollas vegnan abolidas. Ellas pon vegnir eliminadas, ma betg attribuidas.",
    "admin_users.deprecated_roles_warning_body": "{deprecatedRoles} vegnan abolids. Per mintga administratur marcà sutvart, agiunta ina da {currentRoles}, alura allontanescha il rolla abolì.",
    "admin_users.deprecated_roles_warning_title": "Admins cun ina rolla deprecada: {count}",
    "admin_users.emails_placeholder": "Adressas dad e-mail dals utilisaders che Vus vulais agiuntar",
    "admin_users.heading": "Admin user",
    "admin_users.loading_message": "Adminis vegnan chargiads...",
    "admin_users.updating_roles_message": "Las rollas vegnan actualisadas…",
    "admins.actions.edit": "Modifitgar",
    "admins.actions.revoke": "Revocar dretgs",
    "admins.actions.revoke-failed": "Sbagl tar la revocaziun dals dretgs d'admin da {userIdentity}",
    "admins.actions.revoked": "{userIdentity} ha nagins dretgs d'admin pli",
    "admins.all_admins": "Tuts",
    "admins.column_actions": "Acziuns",
    "admins.column_name": "Num",
    "admins.column_posts": "Contribuziuns",
    "admins.column_roles": "Dretgs interns",
    "admins.column_title": "Titel",
    "admins.error": "Impussibel d'obtegnair la tabella d'admin",
    "admins.tab_label": "Profils da collavuratur:as",
    "admins.table.search": "Tschertgar…",
    "admins.title": "Profils da collavuratur:as",
    "agree": "D'accord",
    "ai-helper.bullet": "👉 {tipText}",
    "ai-helper.rephrase_message": "Considera da reformular tes messadi per cuntanscher ina pli vasta publicitad e promover discussiuns pli significativas.",
    "ai-helper.suggestions_title": "Propostas",
    "ai-helper.tips_title": "Emprova da suandar quests cussegls:",
    "aitag.ai_moderated": "Moderà da IA",
    "appError.goHome": "Enavos",
    "appError.page_forbidden": "Voss conto n'ha nagin access a questa pagina.",
    "appError.page_not_found": "La pagina che Vus tschertgais n'exista betg.",
    "appError.page_unauthorized": "Vus n'avais nagin access a questa pagina.",
    "article.admin_only_error": "Vus stuais As colliar sco administratur per pudair vesair questa pagina.",
    "article.login_button": "As colliai (log in)",
    "article.no_teaser_error": "Teaser betg definì",
    "article.zdf_section": "ZDF",
    "article_teaser_position.max_positions": "Lubì maximalmain 2 posiziuns",
    "audience_input.community_guidelines_title": "Netichetta",
    "audience_input.composer_placeholder": "Partai Voss patratgs...",
    "audience_input.your_reply_label": "Vossa resposta",
    "audience_input_template.description": "Rimnar dumondas, testimonis ed istorgias d'utilisad:ras. Quai po augmentar la participaziun.",
    "audience_input_template.label": "Input dal public (AMA)",
    "blocklist.add_term_button": "Agiuntar term",
    "blocklist.add_terms": "Agiuntar terms - separar plirs terms cun ;",
    "blocklist.delete_confirmation": "Dovran quests terms propi vegnir stizzads? Vus pudais agiuntar els puspè pli tard.",
    "blocklist.delete_terms": "Stizzar terms",
    "blocklist.edit_term": "Modifitgar il term",
    "blocklist.empty_list": "La glista naira è vida.",
    "blocklist.help_alternative_spellings_description": "Vus pudais decider sche ortografias alternativas vegnan resguardadas. Las suandantas ortografias, cifras e segns specials vegnan er resguardads:",
    "blocklist.help_alternative_spellings_title": "Ortografias alternativas:",
    "blocklist.help_case_note": "Grondas e pitschnas letras vegnan resguardadas",
    "blocklist.help_character_replacements": "A → a  | a → A | a → @ | a → 4 | i → 1 | e → 3 | o → 0 | s → $ | s → 5 | t → 7 | b → 8 | g → 9",
    "blocklist.help_intro": "La glista da bloc permetta da definir terms che vegnan automaticamain impedids da vegnir publitgads en posts da la communitad. Vus pudais agiuntar terms a questa pre-moderaziun sez. Agiuntai tut ils terms che na duain betg vegnir publitgads senza revisiun umana a la glista.",
    "blocklist.help_singular_term_description": "Vus pudais decider sche be il term singular duai vegnir considerà u er terms che cuntegnan il term inditgà.",
    "blocklist.help_singular_term_example": "Exempel: “persuna” (term singular) → “persunas”. “persunas” vegniss er resguardà sch'il checkbox “term singular” na fiss betg activà per “persuna”. Quai vala er per la chadaina “persunalitad”, per exempel.",
    "blocklist.help_singular_term_title": "Term singular:",
    "blocklist.include_alternative_spellings": "Includer scripziuns alternativas",
    "blocklist.no_results": "Nagin endata correspunda a tia tschertga.",
    "blocklist.only_singular_term": "Sulet pled singular",
    "blocklist.settings_for_term": "Impostaziuns per il term",
    "blocklist.single_term_added_success": "Il term \"{singleTerm}\" è vegnì agiuntà",
    "blocklist.single_term_not_deleted": "Il term da la glista da blocca n'ha betg pudì vegnir stizzà",
    "blocklist.singular_term_tag": "Pled singular",
    "blocklist.term_adoption_description": "Selecziunai, sch'ils pleds duain vegnir surpigliadas exactamain sco quai che Vus als avais inditgà, u sch'els duain vegnir surpigliads en furma schlargiada.",
    "blocklist.term_already_in_list": "Quest term è gia en la glista",
    "blocklist.term_required": "In term sto vegnir inditgà",
    "blocklist.terms_added_success": "{termsCount} terms èn vegnids agiuntads cun success",
    "blocklist.terms_already_in_list": "Quest term è gia en la glista",
    "blocklist.terms_may_not_be_longer_than": "Ils terms na dastgan betg esser pli lungs che 150 caracters.",
    "blocklist.terms_not_added_duplicate": "Il term da la glista da blocca exista gia: {duplicateTerms}",
    "blocklist.terms_not_added_mixed": "Il term da la glista da blocca exista gia: {duplicateTerms}. Il term da la glista da blocca n'ha betg pudì vegnir agiuntà, per plaschair emprova anc ina giada: {refusedTerms}",
    "blocklist.terms_not_added_refused": "Il term da la glista da blocca n'ha betg pudì vegnir agiuntà, per plaschair emprova anc ina giada: {refusedTerms}",
    "blocklist.terms_not_deleted": "{failedCount} da {totalCount} terms da la glista da blocca n'han betg pudì vegnir stizzads",
    "blocklist.title": "Glista da bloc",
    "blocklist.too_long_terms_removed": "Ils terms pli lungs che 150 caracters èn vegnids allontanads.",
    "button.react": "Reagir",
    "button.react_button_aria": "{count} {tLabel} ({tSelected})",
    "button.react_button_deselected": "deactivà",
    "button.react_button_selected": "Selecziunà",
    "button.reacted": "Reagì",
    "byline.deleted_user": "Utilisad:ra stizzada",
    "byline.edited": "Edità",
    "byline.post_id": "ID:",
    "channel_settings.title": "Configuraziun dal chanal",
    "channels.add_channel_button": "Agiuntar chantun",
    "channels.channels_label": "Chantuns",
    "channels.default_channel_label": "Chantun standard",
    "channels.delete_tooltip": "Vus na pudais betg stizzar il chantun standard ni chantuns che vegnan duvrads",
    "channels.image_preview": "Prevista da l'imagen",
    "channels.manage_channels_heading": "Administrar chantuns",
    "channels.no_channel": "Nagin canal",
    "channels.no_channels_available": "Nagin chanal disponibel",
    "channels.no_channels_available_info": "Creescha e gestiunescha ils chanals en il dashboard da moderaziun.",
    "channels.not_channel_member_warning": "Vus n'essas betg commember dal chantun, quai deactivescha tschertas funcziuns!",
    "channels.select_channel": "Tschernar in chanal",
    "channels.title": "Chanal",
    "close_conversation.closed_message": "Questa conversaziun è serrada uss.",
    "comment.cancel_button": "Annullar",
    "comment.confirm_leave_description": "Las midadas fatgas na vegnan betg arcunadas.",
    "comment.confirm_leave_heading": "Propi bandunar la pagina?",
    "comment.delete_button": "Stizzar",
    "comment.delete_modal_heading": "Vulais Vus propi stizzar quest post?",
    "comment.delete_modal_warning": "Questa acziun na po betg vegnir revedida.",
    "comment.edit_button": "Editar",
    "comment.post_button": "Contribuir",
    "comment.posting": "Vid publitgar…",
    "comment.public_comment_subtitle": "Commentari public",
    "comment.read_more_button": "Leger dapli",
    "comment.reply_button": "Respunder",
    "comment.report_button": "Rapportar",
    "comment.show_less": "Mussar pli pauc",
    "comment.show_more_replies_plural": "Mussar {count} ulteriuras respostas",
    "comment.show_more_reply_singular": "Mussar {count} ulteriura resposta",
    "comment.show_original": "Mussar l'original ({language})",
    "comment.show_translation": "Mussar traducziun ({language})",
    "comment.update_button": "Actualisar",
    "comment.updating": "Vid actualisar…",
    "comment.your_reply_label": "Vossa resposta",
    "comment_feedback.only_visible_to_you": "Visibel mo per Vus",
    "comment_slider.change_vote_button": "Actualisai Vossa resposta",
    "comment_slider.community_guidelines_title": "Netichetta",
    "comment_slider.its_complicated": "Igl è cumplitgà",
    "comment_slider.no_with_reservations": "Na cun resalvas",
    "comment_slider.public_response": "Resposta publica",
    "comment_slider.recording_vote": "Vid prender si il votum…",
    "comment_slider.response": "resposta",
    "comment_slider.responses": "respostas",
    "comment_slider.share_thoughts": "Partai Voss patratgs",
    "comment_slider.skip_change_vote": "Sursiglir e midar il votum",
    "comment_slider.skip_submit_vote": "Sursiglir e votar",
    "comment_slider.slide_to_respond": "Stuschar per respunder:",
    "comment_slider.strongly_no": "Cleramain NA",
    "comment_slider.strongly_yes": "Cleramain GEA",
    "comment_slider.update_response": "Actualisai Vossa resposta",
    "comment_slider.yes_with_reservations": "GEA cun resalvas",
    "comment_slider.your_reply_label": "Vossa resposta",
    "comment_slider_editable_positions.heading": "Adattar il comment slider",
    "comment_slider_template.description": "Dumandar las utilisad:ras da respunder a la dumonda sin in spectrum (p.ex. „insumma betg“ fin „dal tuttafatg“).",
    "comment_slider_template.label": "Comment-Slider",
    "common.access_denied": "Access refusà",
    "common.are": "èn",
    "common.cancel": "Interrumper",
    "common.download": "download",
    "common.is": "è",
    "common.loading": "Vid chargiar…",
    "common.select": "Selecziunar",
    "community_guidelines.aria_popup_label": "{label} (Fanestra popup)",
    "community_guidelines.category_engage_respectfully": "As cuntegnai cun respect",
    "community_guidelines.category_no_disruptive_behavior": "Nagin cumportament che disturba",
    "community_guidelines.category_no_harmful_content": "Nagins cuntegns che fan donn",
    "community_guidelines.category_support_claims": "Annotai mussaments per Vossas pretensiuns",
    "community_guidelines.constructive_content_explanation": "**Commentaris che pudessan esser pli constructivs** pon survegnir propostas co els pon s'accordar meglier cun nossas reglas da la community. Vus avais la pussaivladad da surlavurar Voss commentari u da publitgar el uschia. Commentaris che vegnan publitgads suenter avair survegnì propostas senza vegnir surlavurads pon vegnir classifitgads pli bass en il feed per priorisar contribuziuns pli constructivas.",
    "community_guidelines.guidelines_intro": "Nossas directivas da la community èn:",
    "community_guidelines.harmful_content_explanation": "**Cuntegns nuschaivels** che cuntrafan a las directivas da la community vegnan bloccads. Sche questa decisiun è vegnida prendida da l'IA, pudais Vus trametter Vossa contribuziun ad ina moderatur:a umana per la laschar controllar. \n\n **Commentaris che pudessan esser pli constructivs** pon survegnir propostas co meglier respunder a las directivas da la community. Vus avais la pussaivladad da surlavurar Voss commentari u da publitgar el uschia. Commentaris che vegnan publitgads senza vegnir surlavurads suenter avair survegnì propostas pon vegnir classifitgads pli bass en il feed per priorisar contribuziuns pli constructivas.",
    "community_guidelines.modal_heading": "Directivas e normas da la community",
    "community_guidelines.modal_intro": "Nus ans stentain d'inspirar en quest spazi discurs genuins, plain respect ed averts. Mintgin è bainvegnì da parter sias experientschas; da parter puncts da vista, da debattar e da far dumondas en il spiert d'amicabladad e da marveglias.",
    "community_guidelines.moderation_explanation": "Quest spazi è concepì per discurs pli approfundads che commentaris tipics da l'internet. Noss process da moderaziun gida a mantegnair quest standard respectond Vossa vusch e Voss punct da vista.",
    "community_guidelines.norms_intro": "Nossas normas da la community èn:",
    "community_guidelines.rule_avoid_derogatory_labels": "Evitai etichettas pegiurativas",
    "community_guidelines.rule_avoid_sarcasm": "Evitar sarcassem e respostas refusantas",
    "community_guidelines.rule_explain_constructively": "Declerai differenzas d'opiniun a moda constructiva",
    "community_guidelines.rule_express_civility": "Exprimi Vossas ideas a moda curtaschaivla",
    "community_guidelines.rule_focus_on_ideas": "As concentrai sin ideas, betg sin giudicaments da caracter",
    "community_guidelines.rule_no_illegal_content": "Nagins cuntegns illegals",
    "community_guidelines.rule_no_offtopic": "Naginas contribuziuns che n'han betg da far cun il tema",
    "community_guidelines.rule_no_spam": "Nagin spam u reclama commerziala",
    "community_guidelines.rule_no_violent_content": "Nagins cuntegns violents u appels da chaschunar donns",
    "community_guidelines.rule_provide_sources": "Inditgar funtaunas tar pretensiuns",
    "community_guidelines.rule_respect_privacy": "Respectai la sfera privata dad auters, betg parter infurmaziuns persunalas",
    "community_guidelines.title": "Netichetta",
    "community_guidelines.what_happens_heading": "Tge capita sche Vossa contribuziun cuntrafa a las directivas u normas da la community?",
    "context_entry_points.From": "Da",
    "context_entry_points.joined_from": "Vegni:da da",
    "conversation_helper.analyze_conversation": "Analisar discurs",
    "conversation_helper.checks_performed": "- **fatg {count} analisa(s) da discurs**",
    "conversation_helper.conversation_analysis": "Analisa dal discurs",
    "conversation_helper.conversation_stats": "Statisticas da discurs",
    "conversation_helper.conversation_summary": "Resumaziun dal discurs",
    "conversation_helper.current_guidance": "Avis actual",
    "conversation_helper.dashboard": "Dashboard d'agid da conversaziun",
    "conversation_helper.disagree": "Betg d'accord",
    "conversation_helper.explanation": "Explicaziun",
    "conversation_helper.generate_new_guidance": "Generar in nov avis",
    "conversation_helper.generated_because": "Quest avis è vegnì generà perquai che...",
    "conversation_helper.guidance_messages_generated": "- **generà {count} avis**",
    "conversation_helper.guidance_visible_to_everyone": "Quest avis è visibel per tuts.",
    "conversation_helper.hello_everyone": "Tgau ensemen!",
    "conversation_helper.help_history": "Cronologia d'agid",
    "conversation_helper.helpful": "gidaivel",
    "conversation_helper.last_analysis_none": "- Ultima analisa da discurs: **Nagina**",
    "conversation_helper.last_analysis_time": "- Ultima analisa da discurs: **{time}**",
    "conversation_helper.new_comments_since_analysis": "- **{count} nov(s) commentari(s)** dapi l'ultima analisa",
    "conversation_helper.no_history": "I na dat nagina cronologia",
    "conversation_helper.no_problems": "Chattà nagins problems.",
    "conversation_helper.open_admin_dashboard": "Avrir il Dashboard d'administraziun",
    "conversation_helper.problems_detected": "Chattà problems!",
    "conversation_helper.related_space": "Discurs correspundent",
    "conversation_helper.result": "Resultat:",
    "conversation_helper.thank_you": "Grazia",
    "conversation_home.about_heading": "Davant {brandName}",
    "conversation_home.brand_name": "l'incubatur da spazis publics",
    "conversation_home.citizen_conversation": "Prenda part ad ina conversaziun genuina",
    "conversation_home.citizen_conversation_description": "Condivida tia perspectiva en in spazi pensà per dialog constructiv e ponderà.",
    "conversation_home.error_loading": "Errur tarchargiar las conversaziuns.",
    "conversation_home.focused_topics": "Approfundescha ils temas che t'affectan",
    "conversation_home.focused_topics_description": "Las conversaziuns cumenzan cun ina dumonda u proposta clera, per mantegnair la discussiun concentrada e significativa.",
    "conversation_home.hero_subtitle": "Saja la discussiun cun noss giurnalists e persunas da l'entir pajais.",
    "conversation_home.hero_title": "Conversaziuns ponderadas davart temas che t'interesseschan",
    "conversation_home.latest_title": "Explora las ultimas discussiuns",
    "conversation_home.no_conversations": "Anc naginas conversaziuns.",
    "conversation_home.with_experts": "Collia directamain cun experts e schurnalists",
    "conversation_home.with_experts_description": "Fai dumondas, survegn ina chapientscha pli profunda e collia directamain cun vuschs crediblas che ti stimas.",
    "cta_button.loading": "Vid chargiar",
    "dashboard.table.demo.pagination": "Spazis (per pagina)",
    "dashboard.table.demo.users": "Spazis",
    "date.days_abbrev": "{days} dis",
    "date.hours_abbrev": "{hours} uras",
    "date.minutes_abbrev": "{minutes} min.",
    "date.months_abbrev": "{months} mais",
    "date.now": "uss",
    "date.years_abbrev": "{years} onns",
    "deleted_post.author_deleted": "L'autur ha stizzà quest post.",
    "deleted_post.deleting": "Vegn stizzà…",
    "deleted_post.you_deleted": "Vus avais stizzà quest post.",
    "demo.comment": "Commentari",
    "demo.comments": "Commentaris",
    "demo.count_noun": "{count} {noun}",
    "demo.disagree": "Betg d'accord",
    "demo.fwrd": "FFWD",
    "demo.load_video_element": "Chargiar element da video",
    "demo.new_to_me": "Nov per mai",
    "demo.pause": "PAUSA",
    "demo.play": "PLAY",
    "demo.prev": "ENAVOS",
    "demo.respect": "Respect",
    "demo.thank_you": "Grazia",
    "demo.tile_admin_users_description": "Administraziun dals dretgs d'utilisaders.",
    "demo.tile_admin_users_label": "Admin user",
    "demo.tile_topics_label": "Temas",
    "developer_tools.email_testing": "Test dad e-mail",
    "developer_tools.email_testing_description": "Trametta in e-mail da test a l'adressa d'e-mail da tes conto.",
    "developer_tools.installed_versions": "Versiuns installadas",
    "developer_tools.key": "Clav",
    "developer_tools.send_test_email": "Trametter e-mail da test",
    "developer_tools.sending": "Trametter…",
    "developer_tools.test_email_sent": "E-mail da test tramess cun success via {provider}",
    "developer_tools.title": "Tools per sviluppaders",
    "developer_tools.translation_queue": "Queue da translaziuns",
    "developer_tools.translation_queue_description": "Il process penda tar translaziun per il silo actual.",
    "developer_tools.translation_queue_done": "Elavuraziun da la queue da translaziuns a fin",
    "developer_tools.translation_queue_locked": "La queue è – bloccada - in auter process marscha gia.",
    "developer_tools.translation_queue_process": "Queue da process",
    "developer_tools.translation_queue_processing": "Vid processar…",
    "developer_tools.translation_queue_result": "Elavurà: {processed}, Betg funcziunà: {failed}, Sursiglì: {skipped}",
    "developer_tools.translation_queue_stats": "Jobs en la queue: {total} ({pending} pendent, {failed} betg funcziunà)",
    "developer_tools.unable_to_display": "Variablas dal conturn (Ambient) na pon betg vegnir mussadas.",
    "developer_tools.value": "Valur",
    "developer_tools.version_client": "Client",
    "developer_tools.version_server": "Server",
    "developer_tools.version_unknown": "Nunenconuschent",
    "dialogue.recording_vote": "La vusch vegn nudada…",
    "dialogue.response_count": "{total} respostas",
    "dialogue.response_plural": "{count} respostas",
    "dialogue.response_singular": "{count} resposta",
    "dialogue.share_your_thoughts": "Cundividai Voss patratgs",
    "dialogue.skip_submit_vote": "Sursiglir e votar",
    "dialogue.update_response": "Adattai Vossa resposta",
    "dialogue_editable_labels.heading": "Adattar las opziuns da resposta",
    "dialogue_template.description": "Dumandar las utilisad:ras da respunder cun in simpel 'gea' u 'na'.",
    "dialogue_template.label": "Dialog",
    "disagree": "Betg d'accord",
    "editable_positions_widget.button_label": "Editar las posiziuns",
    "editable_positions_widget.label": "Posiziun #{position}",
    "editorial_dash.title": "Dashboard redacziunal",
    "editorial_experts.with-experts": "Cun experts redacziunals",
    "editorial_question.be_first": "Sajas l'emprima persuna che parta ses patratgs",
    "editorial_question.count_noun": "{count} {noun}",
    "editorial_question.join_discussion": "Participar al discurs",
    "editorial_question.lets_talk": "Lain discurrer",
    "editorial_question.response_singular": "contribuziun",
    "editorial_question.responses_plural": "contribuziuns",
    "editorial_question.share_thoughts": "Cundividai Voss patratgs",
    "error.api": "Insatge n'ha betg funcziunà",
    "error.network": "Sbagl da colliaziun. Per plaschair controllar vossa colliaziun a l'internet ed empruvai anc ina giada.",
    "features.srg_section": "SRG SSR",
    "filter_list_popover.trigger_more_filters": "Auters filters",
    "footer.made_by": "Creà da",
    "form.accordion.hide_details": "Zuppentar ils detagls",
    "form.accordion.show_details": "Mussar ils detagls",
    "form.add_button": "Agiuntar",
    "form.adding_button": "Vegn agiuntà...",
    "form.cancel_button": "Interrumper",
    "form.create_space_button": "Crear spazi",
    "form.delete_button": "Stizzar",
    "form.edit_button": "Editar",
    "form.other": "Aut:ras",
    "form.remove_button": "Allontanar",
    "form.required_label": "{label} (obligatoric)",
    "form.save_button": "Arcunar",
    "form.uncheck_all": "Deselecziunar tut",
    "form.update_button": "Actualisar",
    "format.count_noun": "{count} {noun}",
    "invite_user.button": "Envidar in utilisader",
    "invite_user.error": "Envidar {email} n'ha betg funcziunà. Empruvar anc ina giada.",
    "invite_user.modal.email_label": "Adressa dad e-mail",
    "invite_user.modal.heading": "Envidar in utilisader",
    "invite_user.modal.invite_button": "Envidar",
    "invite_user.modal.subheading": "Envida insatgi d'esser in [redactional user] ((https://newpublic.notion.site/Technical-support-2e7fbd65fb3e80e39f11f750d0f5b129) en ils tolls da PSI.",
    "invite_user.success": "{email} è vegnì envidà.",
    "language.de-CH": "tudestg (Svizra)",
    "language.de-DE": "tudestg",
    "language.en-US": "englais",
    "language.fr-BE": "franzos (Belgia)",
    "language.fr-CA": "franzos (Canada)",
    "language.fr-CH": "franzos (Svizra)",
    "language.fr-FR": "franzos",
    "language.it-CH": "talian (Svizra)",
    "language.it-IT": "talian",
    "language.nl-NL": "ollandais",
    "language.rm-CH": "rumantsch",
    "legal.privacy_notice": "Infurmaziun davart la protecziun da datas",
    "legal.terms_of_service": "Cundiziun d'utilisaziun",
    "linked_partner_story.incomplete_list_banner": "Questa glista d'artitgels è eventualmain incumpletta.",
    "linked_partner_story.linked_articles_description": "Guardar artitgels ch'èn colliads cun questa debatta.",
    "linked_partner_story.linked_articles_heading": "Artitgels colliads",
    "linked_partner_story.no_articles_found": "Anc nagins artitgels èn colliads cun quest sectur.",
    "linked_partner_story.read_article_link": "Leger l'artitgel",
    "linked_partner_story.view_video_link": "Guardar il video",
    "list.selected_items_count": "{keyCount} elements tschernids",
    "llm_ranking.best": "Ils meglers",
    "loading": "Chargia…",
    "login.account_blocked_explanation": "I na dovra nagina acziun. Mo in moderatur po restabilir Voss access a la discussiun.",
    "login.account_blocked_heading": "Vus na pudais betg As annunziar, perquai che Voss conto è bloccà",
    "login.account_not_impacted": "Voss {siloName} conto n'è betg pertutgà ed è anc adina accessibel.",
    "login.continue_with": "Cuntinuar cun {providerName}",
    "login.continue_with_google": "Cuntinuar cun Google",
    "login.default_admin_login_heading_label": "Bainvegni tar {psiBrandName}",
    "login.default_admin_login_subheading_label": "S'annunziai cun Voss conto d'admin per cumenzar",
    "login.default_login_heading_label": "In spazi per saunas discussiuns e differents puncts da vista",
    "login.dev_login": "Login per sviluppad:ras",
    "login.logging_in": "Vid annunziar...",
    "login.okay_button": "Okay",
    "login.select_dev_persona": "Tscherni ina persona da sviluppad:ra",
    "login.sso_error": "Annunzia n'ha betg funcziunà. Serrai per plaschair questa fanestra ed empruvai anc ina giada.",
    "main.checkbox.label": "Novas contribuziuns che vegnan controlladas",
    "modal.cancel_button": "Annullar",
    "modal.close_button": "Serrar",
    "modal.confirm_leave_button": "Sortir",
    "modal.info_title": "Infurmaziun",
    "moddashboard.cannot_reply": "Vus na pudais betg respunder a questa publicaziun.",
    "moddashboard.cannot_reply_deleted": "Vus na pudais betg respunder ad ina publicaziun stizzada.",
    "moddashboard.failed_to_post_reply": "Betg reussì da publitgar la resposta",
    "moddashboard.publicly_reply_as": "Respunder publicamain sco",
    "moddashboard.reply_description": "Vossa resposta vegn publicada en il spazi da conversaziun ed è visibla per tut ils utilisaders.",
    "moddashboard.reply_posted_successfully": "Vossa resposta è vegnida publicada cun success",
    "moddashboard.reply_to_user": "Respunder a {userName}...",
    "moddashboard.your_reply": "Vossa resposta",
    "moderate_dialog.locked_name": "{name} controllà",
    "moderate_spaces.title": "Moderar spazis",
    "moderation.add_explanation_to_user": "Agiuntar ina explicaziun al utilisader",
    "moderation.admin_bypass_ai_and_manual_moderation": "Quest sectur vegn moderà cun agid d'IA e manual, ma Vus guntgis omadus automaticamain sco utilisader admin.",
    "moderation.admin_bypass_ai_moderation": "Quest sectur vegn moderà cun agid d'IA, ma Vus la guntgis automaticamain sco utilisader admin.",
    "moderation.admin_bypass_flag": "Vus avais surpassà in signal d'IA",
    "moderation.admin_bypass_manual_moderation": "Quest sectur ha activà la moderaziun manuala, ma Vus guntgis quella automaticamain sco utilisader admin.",
    "moderation.admin_bypassed": "⚠️ L'AI ha marcà tia resposta, ma ti l'has circumventà automaticamain sco utilisader Admin.",
    "moderation.admin_filter_notice": "Per meglierar la moderaziun d'IA, tramettai per plaschair in screenshot da Vossa contribuziun e da quest messadi a Voss team.",
    "moderation.ai_and_manual_label": "Moderà cun agid d'IA e manual",
    "moderation.ai_flag": "Bandiera IA",
    "moderation.ai_mistake_explanation": "IA gida nus da moderar commentaris, po dentant mintgatant far sbagls. Sche l'IA impedescha da parter in'opiniun preschentada cun respect, tramettai il commentari ad in moderatur per al laschar controllar.",
    "moderation.ai_wrong_question": "Ha l'IA fatg in sbagl?",
    "moderation.approved_tag": "Approvà",
    "moderation.automaticallyApproved": "Approvà automaticamain",
    "moderation.awaitingDecision": "Decisiun pendenta",
    "moderation.blocked": "Bloccà",
    "moderation.bypassedPremoderation": "Guntgì la premoderaziun",
    "moderation.check_your_thing": "⚠️ Controllescha tes {moderatedThing}",
    "moderation.dash.add_explanation_to_user": "Agiuntar ina decleraziun per l'utilisad:ra",
    "moderation.dash.approve": "Approvar",
    "moderation.dash.approve_toast": "Approvà",
    "moderation.dash.base_filter._rejected": "Refusà manualmain",
    "moderation.dash.base_filter.approved": "Approvà",
    "moderation.dash.base_filter.auto_approved": "Approvà automaticamain",
    "moderation.dash.base_filter.awaiting_decision": "Decisiun pendenta",
    "moderation.dash.base_filter.bypassed_premod": "Guntgì la premoderaziun",
    "moderation.dash.base_filter.deleted_by_user": "Stizzà da l'utilisad:Ra",
    "moderation.dash.base_filter.manually_approved": "Approvà manualmain",
    "moderation.dash.base_filter.my_bookmarks": "Mes favurits",
    "moderation.dash.base_filter.warnings": "Admoniziuns",
    "moderation.dash.block": "Bloccar",
    "moderation.dash.block_user": "Bloccar utilisad:ras",
    "moderation.dash.blocked": "Bloccà",
    "moderation.dash.blocking_info": "L'utilisad:ra na po betg pli s'annunziar en il spazi da discussiun. Ina utilisad:ra sto vegnir admonida 2 giadas avant ch'ella po vegnir blocca:da.",
    "moderation.dash.cancel_rejection": "Interrumper",
    "moderation.dash.explanation_to_user": "Decleraziun per l'utilisad:ra",
    "moderation.dash.feature_disabled": "Questa funcziun è deactivada.",
    "moderation.dash.finish_rejecting": "Concluder la refusa",
    "moderation.dash.judgement_card.moderate": "Moderar",
    "moderation.dash.operation_error": "L'operaziun n'ha betg funcziunà, per plaschair anc ina giada empruvar",
    "moderation.dash.reject": "Refusar",
    "moderation.dash.reject_toast": "Refusà",
    "moderation.dash.select_all_that_apply": "Tscherni tut quai che correspunda.",
    "moderation.dash.this_account_is_blocked": "Quest conto è bloccà.",
    "moderation.dash.time": "giada",
    "moderation.dash.times": "giadas",
    "moderation.dash.user_already_warned": "Questa utilisad:ra è gia vegnida admonida da {count} {noun}.",
    "moderation.dash.user_must_be_warned_2_times": "In:a utilisad:ra so vegnir averti:da 2 giadas avant ch'el:la po vegnir blocca:da.",
    "moderation.dash.user_successfully_blocked": "{user} bloccà cun success",
    "moderation.dash.user_successfully_unblocked": "{user} è vegnida debloccada",
    "moderation.dash.user_successfully_warned": "{user} è vegnida admonida",
    "moderation.dash.warn_or_block_user": "Admonir u bloccar utilisad:ras?",
    "moderation.dash.warn_user": "Admonir l'utilisad:ra",
    "moderation.dash.warning_email_info": "L'utilisad:ra survegn in avis via e-mail ch'ella è vegnida admonida. Vus pudais pli tard allontanar l'admoniziun dal conto d'utilisad:ra.",
    "moderation.dash.what_guidelines_violated": "Tge directivas violescha quest commentari?",
    "moderation.deletedByUser": "Stizzà da l'utilisad:ra",
    "moderation.deletedUser": "Utilisad:ra stizza:da",
    "moderation.edit_your_post_button": "Modifitgar tes post",
    "moderation.email_notification": "Vus survegnis in e-mail, sche Vossa contribuziun è vegnida approvada u refusada da las moderatur:as.",
    "moderation.email_notification_notice": "Vus survegnis in e-mail, sche Vossa contribuziun è vegnida approvada u refusada da las moderatur:as.",
    "moderation.explanations_sent_by_email": "Explicaziuns vegnan tramessas directamain al utilisader per e-mail suenter che ti has refusà.",
    "moderation.heated": "Ardent",
    "moderation.incompatible_warning": "La controlla cun IA ha mussà che Voss {moderatedThing} na correspunda forsa betg a las suandantas [Community-Rules]($onPress):",
    "moderation.infoBannerLoader.label": "Verificaziun da Vossa resposta...",
    "moderation.info_ai_and_manual_moderation_banner_text": "Per garantir in ambient amiaivel e da respect vegnan tut las contribuziuns en quest sectur moderadas tant cun agid dad IA sco er manualmain avant ch'ellas vegnan publitgadas per garantir ch'ellas correspundian a las [Community Guidelines]($onPress).",
    "moderation.info_ai_moderation_banner_text": "Per garantir in ambient amiaivel e da respect vegnan las contribuziuns en quest sectur moderadas cun IA. L'IA po marcar Vossa contribuziun per anc ina controlla pli intensiva sch'ella na correspunda betg a las [Community Guidelines]($onPress).",
    "moderation.info_manual_moderation_banner_text": "Per garantir in ambient amiaivel e da respect vegnan tut las contribuziuns en quest sectur moderadas manualmain avant ch'ellas vegnan publitgadas per correspunder a las [Community Guidelines]($onPress).",
    "moderation.liveThread": "Live thread",
    "moderation.manuallyApproved": "Approvà manualmain",
    "moderation.manuallyRejected": "Refusà manualmain",
    "moderation.message_to_moderator_placeholder": "Messadi ad ina moderatur:a…",
    "moderation.mode_ai": "Moderaziun cun IA",
    "moderation.mode_ai_and_manual": "Moderaziun IA e manuala",
    "moderation.mode_ai_post_anyway": "Moderaziun IA e tuttina postar",
    "moderation.mode_manual": "Moderaziun manuala",
    "moderation.new": "Nov",
    "moderation.perspective_label": "Etichetta da puncts da vista",
    "moderation.popular": "Popular",
    "moderation.post_without_editing_button": "Publitgar senza modifitgar",
    "moderation.postedAnyway": "Postà tuttina",
    "moderation.provide_details_help": "Inditgai per plaschair tut ils detagls che pon gidar a l'examinaziun sche Vossa contribuziun correspunda a nossas reglas da communitad.",
    "moderation.rejected_by_moderator": "Refusà da la moderatur:a",
    "moderation.reported_by_n_users": "Rapportà da {count} utilisad:ras",
    "moderation.response": "Resposta",
    "moderation.select_all_that_apply": "Tscherni tut il correspundent",
    "moderation.send_for_review_button": "Trametter ad ina moderatur:a per verificaziun",
    "moderation.send_to_moderator_button": "Trametter a la moderatur:a",
    "moderation.send_to_moderator_title": "Trametter al la moderatur:a",
    "moderation.sending": "Vid trametter...",
    "moderation.sent_for_review_message": "Vossa resposta è vegnida tramessa ad ina moderatur:a per laschar controllar",
    "moderation.sent_to_moderator": "Vossa resposta è vegnida tramessa ad ina moderatur:a per laschar controllar",
    "moderation.sent_to_moderator_time": "Tramess a la moderatur:a: {time}",
    "moderation.share_details": "Inditgar detagls",
    "moderation.singularTerm": "Pled singular",
    "moderation.strict_filter_notice": "⚠️ Noss filter da moderaziun è actualmain fitg sever per garantir il pli aut nivel da segirezza! Sche ti sentas che tia contribuziun vegn refusada nunfairmain, contactescha per plaschair noss team da moderaziun!",
    "moderation.system_unavailable_message": "Noss sistem da moderaziun cun IA n'è temporarmain betg disponibel. Vus pudais tuttina trametter Vossa contribuziun ad ina moderatur:a per la verificaziun.",
    "moderation.system_unavailable_title": "️⚠️ Sistem da moderaziun temporarmain betg disponibel",
    "moderation.take_second_look_rephrase": "📢 Considerescha da reformular tes messadi per cuntanscher ina pli vasta audienza e promover discussiuns pli significativas.",
    "moderation.take_second_look_title": "Tgi ina segunda egliada",
    "moderation.take_second_look_warning": "❗️ Nossa revisiun d'AI propona che tia resposta pudess disturbar persunas che na partan betg tes punct da vista.",
    "moderation.thank_you": "Grazia fitg!",
    "moderation.under_review": "Vegn controllà",
    "moderation.update_without_editing_button": "Actualisar senza modifitgar",
    "moderation.use_ai_title": "✨ Nus utilisain IA per la moderaziun",
    "moderation.warned": "Admonì",
    "moderation.what_guideline_violate": "A tge reglas cuntrafa quest commentari?",
    "moderation.what_happens_next": "📫 Tge capita sco proxim?",
    "moderation.write_additional_explanation": "Scriva ina explicaziun supplementara per il utilisader davart tia refusa.",
    "moderation.zdfComment": "Commentari ZDF",
    "moderation_card.auto_translated": "Translatà automatic",
    "moderation_card.language_tag": "{locale} | Translatà",
    "moderation_card.origin": "Origin:",
    "moderation_card.origin_not_available": "Nagin origin disponibel",
    "moderation_card.show_original": "Mussar l'original ({locale})",
    "moderation_card.show_translation": "Mussar la translaziun ({locale})",
    "moderation_dash.add_your_notes": "Agiuntai Vossas notizias...",
    "moderation_dash.blocklist": "Glista d'utilisadr:as bloccad:as",
    "moderation_dash.channel_settings": "Configuraziuns dal chanal",
    "moderation_dash.community_guideline_violation": "️⚠️ Surpassament da las directivas da la community",
    "moderation_dash.count_users": "{count} utilisaders",
    "moderation_dash.created_by": "Creà da",
    "moderation_dash.explanation_to_user": "Explicaziun a l'utilisader",
    "moderation_dash.internal_notes": "Annotaziuns internas",
    "moderation_dash.manually_rejected": "Refusà manualmain",
    "moderation_dash.message_to_moderator": "Messadi a la moderatur:a",
    "moderation_dash.moderate_spaces": "Moderar spazis",
    "moderation_dash.no_spaces": "Anc nagins spazis",
    "moderation_dash.num_stories": "{numArticles} artitgels",
    "moderation_dash.posts": "Contribuziuns",
    "moderation_dash.posts.title": "Moderar contribuziuns",
    "moderation_dash.premod_eval_tab": "Valitaziun da l'IA",
    "moderation_dash.queue.all_posts_hidden_plural": "{count} contribuziuns èn zuppadas tras ils filters survart.",
    "moderation_dash.queue.all_posts_hidden_singular": "1 contribuziun è zuppada tras ils filters survart.",
    "moderation_dash.queue.load_more": "Chargiar dapli",
    "moderation_dash.queue.no_posts_yet": "Anc naginas contribuziuns.",
    "moderation_dash.rejected_by": "Refusà da",
    "moderation_dash.reported_by": "Rapportà da",
    "moderation_dash.selected_community_guideline_violation": "⚠️ Violaziun selecziunada da las directivas da la cuminanza",
    "moderation_dash.user_report": "Rapport d'utilisader",
    "moderation_queue.button_filters": "Filters",
    "moderation_queue.clear_all": "Stizzar tut",
    "moderationdash.title": "Dashboard da moderaziun",
    "moderationdash.user_information": "Infurmaziuns da l'utilisad:ra",
    "moderationdash.user_metadata.comments_and_replies": "Contribuziuns:",
    "moderationdash.user_metadata.flagged_comments": "Contribuziuns marcadas da l'IA:",
    "moderationdash.user_metadata.rejected_comments": "Contribuziuns refusadas:",
    "moderationdash.user_metadata.reported_comments": "Contribuziuns rapportadas:",
    "moderationdash.user_metadata.user_warnings": "Avertiments:",
    "moderationtag.manually_moderated": "Moderà manual",
    "most_popular.most_popular_label": "Ils pli populars",
    "most_popular.most_recent_label": "Ils ultims",
    "most_popular.show_more_button": "Mussar dapli respostas",
    "navigation_header.back_button": "Enavos",
    "neutral": "Neutral",
    "notification.dismiss_button": "Sbittar",
    "notification.new_moderation_tasks": "Notificaziuns da novas incumbensas da moderaziun ch'èn prontas per controllar",
    "notification.new_moderation_tasks_settings": "Configuraziuns per avis davart novas incumbensas da moderaziun ch'èn prontas per la verificaziun",
    "notification.new_moderation_tasks_settings.checkboxMyChannels": "... en mes chanals",
    "notification.new_moderation_tasks_settings.checkboxSpacesICreated": "... en spazis creads da mai",
    "notification.new_moderation_tasks_settings.checkboxSpacesIFollow": "... en spazis als quals che jau suond",
    "onboarding.dismiss_button": "Serrar",
    "original_language": "Linguatg original",
    "pagination_row.next_page": "Proxima pagina",
    "pagination_row.previous_page": "Pagina precedenta",
    "pagination_row.showing": "Mussar {start}-{end} da {total}",
    "perspectives.add_new_perspective": "Agiuntar in nov punct da vista",
    "perspectives.add_your_own": "Agiuntai Voss'agen",
    "perspectives.add_your_perspective": "Agiuntai Voss punct da vista",
    "perspectives.dont_see_one": "È nagin adattà?",
    "perspectives.edit_invalid_characters": "Etichettas da perspectiva ston cuntegnair almain ina bustab",
    "perspectives.havent_heard_yet": "Nus n'avain anc udì nagut ord quest punct da vista",
    "perspectives.how_relate_question": "Co stais Vus tar quest tema?",
    "perspectives.poll_title": "Contribuziuns fin uss",
    "perspectives.share_thoughts_button": "Partai Voss patratgs",
    "perspectives.title": "Puncts da vista",
    "perspectives.write_in_duplicate": "Questa perspectiva exista gia — tschernia quella or da la glista",
    "perspectives.write_in_empty": "Endatescha in num da perspectiva",
    "perspectives.write_in_invalid_characters": "Etichettas da perspectiva ston cuntegnair almain ina bustab",
    "perspectives.write_in_no_emoji": "Emojis na èn betg lubids en perspectivas persunalas",
    "perspectives.write_in_too_long": "Nums da perspectivas pon avair maximalmain {max} caracters",
    "pin_comment.feature_label": "Accentuar",
    "pin_comment.featured_label": "Accentuà",
    "pin_to_feed.move_down": "Spustar engiu",
    "pin_to_feed.move_up": "Spustar ensi",
    "pin_to_feed.pin_label": "Fixar",
    "pin_to_feed.pinned_label": "Fixà",
    "poll.change_vote_button": "Midar il votum",
    "poll.result_vote": "{tLabel}: {percent}%",
    "poll.result_your_vote": "{tLabel} (Vossa vusch): {percent}%",
    "poll.submit_vote_button": "Votar",
    "poll.write_in_topic": "Scrivai tar in tema…",
    "poll.you": "Ti",
    "poll.you_comment": "Vus ({comment})",
    "poll_question.add_option_button": "Agiuntar in'opziun",
    "poll_question.option_placeholder": "Scrivi Voss'opziun…",
    "poll_question.options_label": "Opziuns da l'enquista",
    "poll_question.question_label": "Dumonda per l'enquista",
    "poll_question.question_placeholder": "Scrivai la dumonda per l'enquista…",
    "poll_result.percent": "{percent}%",
    "popup.close_button": "Serrar la fanestra",
    "popup_tip.more_information": "Dapli infurmaziun",
    "post.post_anyway_button": "Tuttina publitgar",
    "post.posting_anyway": "Tuttina publitgar…",
    "post.submit": "Trametter",
    "post.submitting": "Vegn tramess…",
    "post.update": "Actualisar",
    "post.update_anyway_button": "Tuttina actualisar",
    "post.updating": "Vid actualisar…",
    "post.updating_anyway": "Vid actualisar tuttina…",
    "premod_review.ai_eval_title": "Valitaziun IA",
    "premod_review.ai_flag_label": "Marcaziun IA",
    "premod_review.badge_ai_correct": "IA correct",
    "premod_review.badge_ai_incorrect": "IA incorrect",
    "premod_review.badge_needs_evaluation": "Valitaziun necessaria",
    "premod_review.badge_wrong_reason": "Fallada raschun",
    "premod_review.based_on_evaluations": "Basà sin {count} valitaziuns \"{verdict}\"",
    "premod_review.correct_rules_label": "Reglas correctas",
    "premod_review.disabled": "La registraziun da datas per la verificaziun da la moderaziun preliminara è vegnida deactivada sin quest server. Questa funcziun è activada per standard. Per puspè activar ella, allontanai PREMOD_REVIEW_DISABLED=true da la.env.",
    "premod_review.empty_state": "Naginas contribuziuns per moderaziun en questa categoria.",
    "premod_review.evaluate_title": "Valitar la marcaziun da l'IA",
    "premod_review.evaluation_correct": "L'IA è correcta - contribuziun cuntrafa a directivas",
    "premod_review.evaluation_incorrect": "IA è incorrecta - la contribuziun duess esser permessa",
    "premod_review.evaluation_set_tooltip": "Nus duvrain IA per crear ina nova retscha da contribuziuns sinteticas che han ils medems cas marginals sco quai ch'ellas cumparan en las contribuziuns realas mussadas qua en las datas da valitaziun.",
    "premod_review.evaluation_submitted_toast": "Vossa valitaziun è vegnida inoltrada",
    "premod_review.evaluation_wrong_reason": "Gist da bloccar, ma per il fauss motiv",
    "premod_review.evaluator_explanation": "Decleraziun da la valitad:ra",
    "premod_review.expiration_tooltip": "Commentaris scrodan suenter 30 dis per correspunder a nossas directivas per la protecziun da datas.",
    "premod_review.expired": "Scadì",
    "premod_review.expires_in": "Scada en {days} dis",
    "premod_review.export_description": "Telechargiar ina datoteca cun contribuziuns da questa categoria da valitaziun ch'èn effectivamain vegnidas verifitgadas.",
    "premod_review.export_heading": "Generar datas da valitaziun per il download",
    "premod_review.file_format_label": "Format da la datoteca",
    "premod_review.file_ready": "La datoteca {format} è pronta!",
    "premod_review.filter_ai_correct": "IA correct",
    "premod_review.filter_ai_incorrect": "IA incorrect",
    "premod_review.filter_needs_evaluation": "Valitaziun necessaria",
    "premod_review.filter_wrong_reason": "Faussa raschun",
    "premod_review.format_csv": "CSV",
    "premod_review.format_json": "JSON",
    "premod_review.generate_data": "Generar datas",
    "premod_review.loading": "Chargia…",
    "premod_review.moderate_posts_description": "Dar in resun davart las decisiuns da l'IA da marcar contribuziuns per la moderaziun. Questa lavur creescha datas da valitaziun per meglierar l'exactadad da la premoderaziun da l'IA en il decurs dal temp.",
    "premod_review.post_label": "Contribuziun",
    "premod_review.reason_description": "Quai vegn duvrà per generar datas da trenament sinteticas per meglierar l'IA.",
    "premod_review.reason_label": "Declerai Vossa valitaziun",
    "premod_review.reason_placeholder": "p.ex., \"Quai è critica legitima da la politica, betg in'attatga persunala\"",
    "premod_review.regenerate_data": "Generar las datas danovamain",
    "premod_review.select_format": "Selecziunar il format d'export",
    "premod_review.select_format_description": "Tscherni in format da datoteca per Voss export da datas.",
    "premod_review.space_label": "Spazi",
    "premod_review.submit": "Inoltrar",
    "premod_review.submitting": "Vegn tramess...",
    "premod_review.which_rules_violated_label": "A tge reglas cuntrafa questa contribuziun effectivamain?",
    "premod_review.why_not_ai_rules_label": "Pertge na cuntrafa la contribuziun betg a las reglas citadas da l'IA?",
    "premod_review.why_not_ai_rules_placeholder": "Explitgai pertge che las reglas citadas da l'IA n'èn betg applitgablas…",
    "premod_review.why_violates_label": "Pertge violescha la contribuziun questas reglas?",
    "premod_review.why_violates_placeholder": "Explitgai pertge che questa contribuziun cuntrafa a las reglas che Vus avais tschernì...",
    "premod_review.your_evaluation": "Vossa valitaziun (obligatoric)",
    "privacy.only_visible_to_you": "🔒 Mo visibel per tai",
    "profile.add_custom_name": "Agiuntar in num persunalisà",
    "profile.collaboration_note": "Quest spazi da discussiun vegn fatg il hosten da New_ Public en collavuraziun cun {psmName}.",
    "profile.consent_aria": "Jau sun d'accord cun las Directivas da la communitad, l'Avís da confidenzialitad e las Cundiziuns da servetsch.",
    "profile.consent_text": "Jau sun d'accord cun las [Directivas da la communitad]({communityGuidelinesLink}), l'[Avís da confidenzialitad]({privacyNoticeLink}) e las [Cundiziuns da servetsch]({termsOfServiceLink}).",
    "profile.custom_photo_label": "Foto da profil persunalisà",
    "profile.edit.custom-title": "Agiuntar in titel persunalisà",
    "profile.edit.custom_title": "Agiuntar in titel persunalisà",
    "profile.edit.heading": "Modifitgar",
    "profile.edit.name": "Num dal profil",
    "profile.edit.name_override": "Num",
    "profile.edit.name_override.placeholder": "Agiuntai Voss num alternativ…",
    "profile.edit.override_name_title": "Remplazzar il num dal profil",
    "profile.edit.override_photo_title": "Remplazzar la fotografia dal profil",
    "profile.edit.photo": "Fotografia dal profil",
    "profile.edit.photo_override": "URL da la fotografia",
    "profile.edit.photo_override.placeholder": "Agiuntar URL giavischada…",
    "profile.edit.title": "Titel",
    "profile.edit.windows_title": "Editar: {name}",
    "profile.edit_module_button": "Editar {tLabel}",
    "profile.editorial_info": "Sco utilisader d'admin pudais Vus acceder ulteriuras opziuns per Voss profil en il [redactional-dashboard] (({link}).",
    "profile.error_name_empty": "Nums persunalisads na dastgan betg esser vids.",
    "profile.error_name_invalid": "Nums persunalisads pon cuntegnair mo bustabs pitschens e cifras.",
    "profile.error_name_looks_real": "Nums persunalisads na dastga betg sumegliar nums reals.",
    "profile.error_name_taken": "Quest num d'utilisad:ra vegn gia duvrà.",
    "profile.error_name_violates": "Quest num persunalisà na correspunda betg a las regals da la community.",
    "profile.finish_button": "Finì",
    "profile.go_to.edit": "Editar persunalisaziuns",
    "profile.helper_text": "Tscherna in num ed ina fotografia che cumparan cura che ti publitgeschas en la communitad.",
    "profile.is_titled_writer": "È ina autur:a cun titel",
    "profile.loading": "Il profil vegn chargià…",
    "profile.module_name": "num",
    "profile.module_photo_and_name": "foto e num",
    "profile.name_change_allowed_characters": "Ils nums persunalizads pon mo cuntegnair bustabs pitschens e cifras.",
    "profile.name_label": "Num dal profil",
    "profile.no_user_error": "Nagin tal utilisader",
    "profile.photo_label": "Vossa fotografia dal profil",
    "profile.photo_url_aria": "URL da la fotografia",
    "profile.photo_url_placeholder": "URL da la fotografia",
    "profile.please_wait": "Spetgar per plaschair…",
    "profile.public_overriden": "Vossas infurmaziuns èn vegnidas editadas d'ina administratur:a",
    "profile.setup_title": "Endrizzar in profil",
    "profile.title_heading": "Titel",
    "profile.title_placeholder": "Endatar in titel",
    "profile.username_placeholder": "utilisadra123",
    "profile.warn_overriden": "Vossas infurmaziuns èn vegnidas elavuradas d'in administratur en il [redactional-dashboard]({link}).",
    "profile_answers.admins_can_view": "Administratur:as e moderatur:as pon adina vesair vossa cronologia d'utilisaziun.",
    "profile_answers.discussion_history": "Cronologia da las discussiuns",
    "profile_answers.edit_visibility": "Editar la visibladad",
    "profile_answers.history_private": "La cronologia d'utilisaziun da quest utilisader è privata.",
    "profile_answers.load_more": "Chargiar dapli",
    "profile_answers.rejected": "Il commentari è vegnì refusà d'ina moderatur:a",
    "profile_answers.under_review": "Commentari vegn controllà",
    "profile_answers.visible_to_everyone": "Visibel per tut:tas",
    "profile_menu.dialog_label": "Menu dal profil",
    "profile_menu.menu_label": "Account",
    "prosocial_ranking.toggle_label": "Ranking prosocial",
    "puppet_test_support.login_user_a": "S'annunziar sco utilisadr:a A",
    "puppet_test_support.login_user_b": "S'annunziar sco utilisadr:a B",
    "puppet_test_support.login_user_c": "S'annunziar sco utilisadr:a C",
    "puppet_test_support.reset_silo": "Reinizialisar silo da test",
    "puppet_test_support.secret_label": "Secret Puppet",
    "puppet_test_support.title": "Tools da test Puppet",
    "question.actions.close_button": "Serrar",
    "question.actions.close_confirm_button": "Serrar",
    "question.actions.close_modal_description": "Quest sectur resta legibel sch'el vegn serrà. La gronda part da las acziuns è deactivada e las utilisad:ras na pon betg publitgar, respunder u reagir. Las utilisad:ras pon vinavant rapportar commentaris. Vus pudais da tut temp puspè avrir la debatta.",
    "question.actions.close_modal_heading": "Serrar quest sectur?",
    "question.actions.copy_button": "Copiar",
    "question.actions.edit_button": "Editar",
    "question.actions.link_copied_toast": "Link copià en l'arcun intermediar!",
    "question.actions.linked_stories_button": "Artitgels colliads",
    "question.actions.preview_button": "Previsiun",
    "question.actions.publish_button": "Publitgar",
    "question.actions.publish_confirm_button": "Publitgar",
    "question.actions.publish_modal_description": "Una giada publitgà, quest spazi vegn a esser visibel per utilisaders sin vossa pagina da producziun ed vegn chattà tras SEO. As assicurai che voss cuntegn saja pront per la visualisaziun publica. Vus pudais serrar la conversaziun en mintga mument.",
    "question.actions.publish_modal_heading": "Publitgar quest spazi?",
    "question.actions.publish_success_toast": "Spazi publitgà",
    "question.actions.reopen_button": "Reavrir",
    "question.actions.reopen_confirm_button": "Reavrir",
    "question.actions.reopen_modal_description": "Avrir danovamain quest sectur per reactivar la conversaziun.",
    "question.actions.reopen_modal_heading": "Reavrir quest spazi?",
    "question.actions.tooltip": "Dapliras opziuns",
    "question.actions.unpublish_button": "Betg publitgar",
    "question.actions.unpublish_confirm_button": "Betg publitgar",
    "question.actions.unpublish_modal_description": "Una giada betg publitgà, quest spazi na vegn pli visibel per utilisaders sin vossa pagina da producziun e na vegn pli indexà tras SEO. Vus pudais publitgar puspè la conversaziun en mintga mument.",
    "question.actions.unpublish_modal_heading": "Betg publitgar quest spazi?",
    "question.actions.unpublish_success_toast": "Spazi betg publitgà",
    "question.add_content_label": "Agiuntar cuntegn",
    "question.add_spaces_label": "Agiuntar spazis",
    "question.all_responses_tab": "Tut ils commentaris",
    "question.conversation_format": "Format da discussiun",
    "question.conversation_helper_section": "Agid per la conversaziun",
    "question.conversation_type_section": "Gener da conversaziun",
    "question.count_noun_format": "{count} {noun}",
    "question.edit_closed_banner": "Reavrir quest spazi per l'editar",
    "question.edit_heading": "Editar",
    "question.edit_page_title": "Editar: {name}",
    "question.edit_thread_header_section": "Chau dal spazi",
    "question.edit_view_only_banner": "Ti pos guardar ils parameters da quest spazi, ma betg als midar.",
    "question.error_empty_prompt": "Il prompt na dastga betg esser vid.",
    "question.error_prompt_too_long": "Il prompt na dastga betg esser pli lung che {num} segns.",
    "question.general_section": "General",
    "question.input_placeholder": "Partai Voss patratgs...",
    "question.moderation_approach": "Metoda da moderaziun",
    "question.moderation_label": "Moderaziun",
    "question.no_comments_message": "Sajas l'emprima persuna che parta ses patratgs",
    "question.no_comments_title": "Cumenzai il discurs",
    "question.no_teaser_error": "Nagin teaser definì",
    "question.not_exist": "Questa dumonda n'exista betg",
    "question.playbook_link": "Guardar [editorial playbook]({url}) per dapli infurmaziun.",
    "question.prompt_label": "Prompt",
    "question.prosocial_format_label": "Format prosocial",
    "question.prosocial_ranking_section": "Rangaziun prosociala",
    "question.public_response_subtitle": "Resposta publica",
    "question.reaction_list_tooltip": "Guardar las reacziuns",
    "question.reaction_plural": "reacziuns",
    "question.reaction_singular": "reacziun",
    "question.reply_placeholder": "Respunder a {authorName}…",
    "question.reply_plural": "respostas",
    "question.reply_singular": "resposta",
    "question.select_format_placeholder": "Tscherner in format",
    "question.select_moderation_placeholder": "Terschner ina configuraziun da moderaziun",
    "question.upvote_plural": "vuschs en favur",
    "question.upvote_singular": "vusch en favur",
    "question.your_response_title": "Vossa resposta",
    "ranking-eval.add_ranker": "Agiuntar in classifitgader",
    "ranking-eval.add_source": "Agiuntar funtauna",
    "ranking-eval.back": "Enavos",
    "ranking-eval.builtin_rankers_desc": "Guardai ils prompts dals classifitgaders integrads per referenza per crear ils Voss.",
    "ranking-eval.builtin_rankers_title": "Classifitgaders integrads",
    "ranking-eval.cancel": "Interrumper",
    "ranking-eval.cancel_edit": "Interrumper",
    "ranking-eval.comment_count": "{count} Commentaris",
    "ranking-eval.comment_scoring_desc": "Rangai mintga commentari sin ina scala dad 1-5 stailas",
    "ranking-eval.comments_random_order": "Commentaris en ordinaziun casuala",
    "ranking-eval.conversation_count": "{count} Discurs",
    "ranking-eval.custom_rankers_desc": "Definir classifitgaders persunalisads, dirigids da LLM per als duvrar en ina valitaziun in sper l'auter. Classifitgaders persunalisads cumparan en in dropdown da classifitgaders.",
    "ranking-eval.custom_rankers_title": "Classifitgaders persunalisads",
    "ranking-eval.delete_ranker": "Stizzar",
    "ranking-eval.delete_source": "Stizzar",
    "ranking-eval.disabled": "(deactivà)",
    "ranking-eval.edit": "Editar",
    "ranking-eval.edit_ranker": "Editar classifitgader",
    "ranking-eval.edit_source": "Modifitgar la funtauna",
    "ranking-eval.filter.all_sources": "Tut las funtaunas",
    "ranking-eval.filter_all": "Tuts",
    "ranking-eval.filter_selected": "Tschernì",
    "ranking-eval.first_pass_placeholder": "Utilisescha {{question}} e {{commentText}}",
    "ranking-eval.first_pass_prompt": "Prompt d'emprim pass",
    "ranking-eval.imported_at": "Consultà {time}",
    "ranking-eval.importing": "Discurs vegn importà...",
    "ranking-eval.loading_ranker": "Chargia classifitgader…",
    "ranking-eval.model": "Model",
    "ranking-eval.model_placeholder": "Tscherner il model",
    "ranking-eval.new_ranker": "Nov classifitgader",
    "ranking-eval.new_source": "Nova funtauna",
    "ranking-eval.next_button": "Enavant →",
    "ranking-eval.no_cached": "Anc naginas conversaziuns memorisadas. Cliccai \"Actualisar da las funtaunas\" per retratgar conversaziuns da las paginas partenarias.",
    "ranking-eval.no_comments": "Questa conversaziun n'ha nagins comentaris.",
    "ranking-eval.no_conversations_match": "Naginas conversaziuns che correspundan.",
    "ranking-eval.no_conversations_to_open": "Anc naginas conversaziuns anc. Agiuntar funtaunas en il tab Funtaunas, lura smatgar «Actualisar da las funtaunas» en il tab Set da conversaziuns.",
    "ranking-eval.no_custom_rankers": "Anc nagins rankers persunalisads. Cliccar \"Agiuntar Ranker\" per crear in.",
    "ranking-eval.no_other_ratings": "Anc naginas autras valitaziuns.",
    "ranking-eval.no_ratings_yet": "Anc naginas valitaziuns.",
    "ranking-eval.no_sources": "Anc naginas funtaunas. Clicca sin «Agiuntar funtauna» per agiuntar ina.",
    "ranking-eval.no_sources_to_fetch": "Anc naginas funtaunas. Agiunta ils sites PSI sin il tab Funtaunas per chargiar novitads dad els.",
    "ranking-eval.no_spaces": "Anc nagins spazis. Agiuntai in sura per cumenzar.",
    "ranking-eval.others_ratings": "Valitaziun dad aut:ras",
    "ranking-eval.pick_conversation": "Tscherner discurs",
    "ranking-eval.prev_button": "← Enavos",
    "ranking-eval.ranker_col.actions": "Acziuns",
    "ranking-eval.ranker_col.model": "Model",
    "ranking-eval.ranker_col.name": "Num",
    "ranking-eval.ranker_col.thinking": "Pensar",
    "ranking-eval.ranker_col.topn": "Top N",
    "ranking-eval.ranker_desc_placeholder": "Descripziun curta",
    "ranking-eval.ranker_description": "Descripziun",
    "ranking-eval.ranker_enabled": "Activà",
    "ranking-eval.ranker_name": "Num",
    "ranking-eval.ranker_name_placeholder": "p.ex. debatta constructiva",
    "ranking-eval.ranking_scoring": "Commentaris vegnan valitads…{scored} da {total}",
    "ranking-eval.ranking_selecting_top_10": "Top 10 vegnan tschernids… quai po cuzzar in mument",
    "ranking-eval.ranking_starting": "Rangaziun vegn lantschada…",
    "ranking-eval.rating_reason_placeholder": "Pertge questa valitaziun?",
    "ranking-eval.reasoning": "Nivel dal pensar",
    "ranking-eval.reasoning_placeholder": "Selecziunar nivel",
    "ranking-eval.refresh": "Actualisar ord funtaunas",
    "ranking-eval.refresh_comments": "Actualisar commentaris",
    "ranking-eval.refresh_comments_in_progress": "Commentaris vegnan actualisads...",
    "ranking-eval.refresh_in_progress": "Vegn actualisà...",
    "ranking-eval.refreshing": "Dumandar giu discurs da paginas da partenadi...",
    "ranking-eval.save_ranker": "Arcunar",
    "ranking-eval.save_source": "Memorisar",
    "ranking-eval.scoring_legend_title": "Mussavia da valitaziuns",
    "ranking-eval.search_conversations": "Tschertgar entaifer las conversaziuns…",
    "ranking-eval.second_pass_placeholder": "Utilisescha {{question}} e {{comments}}",
    "ranking-eval.second_pass_prompt": "Prompt da segund pass",
    "ranking-eval.select_conversation": "Tscherner conversaziun",
    "ranking-eval.select_ranker": "Tscherner il classifitgader",
    "ranking-eval.side_by_side_desc": "Cumparegliar dus algoritmus da classificaziun in sper l'auter",
    "ranking-eval.source_base_url": "URL da basa",
    "ranking-eval.source_base_url_placeholder": "p.ex. https://psi.newpublic.org",
    "ranking-eval.source_col.actions": "Acziuns",
    "ranking-eval.source_col.base_url": "URL da basa",
    "ranking-eval.source_col.key": "Clav",
    "ranking-eval.source_col.label": "Etichetta",
    "ranking-eval.source_col.silo": "Silo",
    "ranking-eval.source_key": "Clav",
    "ranking-eval.source_key_placeholder": "p.ex. np",
    "ranking-eval.source_label": "Etichetta",
    "ranking-eval.source_label_placeholder": "p.ex. New Public",
    "ranking-eval.source_remote_silo": "Silo",
    "ranking-eval.source_remote_silo_placeholder": "p.ex. np",
    "ranking-eval.sources_desc": "Sites PSI, dals quals ins po chargiar conversaziuns. «Actualisar da las funtaunas» sin il tab da Set da conversaziuns legia mintgina dad ellas.",
    "ranking-eval.sources_title": "Funtaunas",
    "ranking-eval.sources_unreachable": "Impussibel da cuntanscher {baseUrls}. Controlla sche l'URL da basa è correct en il tab da las funtaunas.",
    "ranking-eval.spaces.column_actions": "Acziuns",
    "ranking-eval.spaces.column_comments": "Commentaris",
    "ranking-eval.spaces.column_created": "Creà",
    "ranking-eval.spaces.column_name": "Num",
    "ranking-eval.spaces.score_comments": "Valitar commentaris",
    "ranking-eval.spaces.side_by_side": "In sper l'auter",
    "ranking-eval.spaces.title": "Spazis",
    "ranking-eval.submit_rating": "Trametter ina valitaziun",
    "ranking-eval.tab.comment_scoring": "Valitaziun dals commentaris",
    "ranking-eval.tab.conversation_set": "Set da conversaziuns",
    "ranking-eval.tab.custom_rankers": "Classifitgaders persunalisads",
    "ranking-eval.tab.side_by_side": "in sper l'auter",
    "ranking-eval.tab.sources": "Funtaunas",
    "ranking-eval.title": "Valitaziun da la rangaziun",
    "ranking-eval.top_n": "Top N",
    "ranking-eval.top_n_placeholder": "20",
    "ranking-eval.top_ten_reasoning": "Top 10 argumentaziuns:",
    "ranking-eval.update_rating": "Actualisar la valitaziun",
    "ranking-eval.view": "Vista",
    "ranking-eval.vote_a_best": "{ranker} è la meglra",
    "ranking-eval.vote_b_best": "{ranker} è la meglra",
    "ranking-eval.vote_tie": "Egual",
    "ranking_debug.recompute": "Recalcular la rangaziun",
    "ranking_debug.recomputing": "Rangaziun vegn recalculada…",
    "ranking_debug.toggle": "Mussar infurmaziuns da debug per la rangaziun",
    "ranking_debug.top_ten_reasoning": "Top 10 argumentaziuns:",
    "ranking_eval.show_debug_info": "Mussar las infurmaziuns da debug",
    "rating.its_complicated": "Igl è cumplitgà",
    "rating.no_with_reservations": "NA cun resalvas",
    "rating.strongly_no": "Ferm NA",
    "rating.strongly_yes": "Ferm GEA",
    "rating.yes_with_reservations": "GEA cun resalvas",
    "reaction_types.appreciation_plural": "likes",
    "reaction_types.appreciation_singular": "like",
    "reaction_types.constructive": "Constructiv",
    "reaction_types.controversial": "Cuntravers",
    "reaction_types.count_noun": "{count} {noun}",
    "reaction_types.default_set": "Set da standard",
    "reaction_types.empathetic": "Empatic",
    "reaction_types.enjoyable": "Amiaivel",
    "reaction_types.fun_space": "Spazi da divertiment",
    "reaction_types.funny": "Legher",
    "reaction_types.helpful": "Nizzaivel",
    "reaction_types.insightful": "Porscha invistas",
    "reaction_types.interesting": "Interessant",
    "reaction_types.nuanced": "Nianzà",
    "reaction_types.personal_space": "Spazi persunal",
    "reaction_types.playful": "Ludic",
    "reaction_types.reaction_set_label": "Set da reacziuns",
    "reaction_types.relatable": "Chapaivel",
    "reaction_types.serious_space": "Spazi serius",
    "reaction_types.surprising": "Surprendent",
    "reaction_types.why_appreciate": "Pertge stimais Vus questa contribuziun?",
    "related_content.add_content_button": "Agiuntar cuntegn",
    "related_content.article_option": "Artitgel",
    "related_content.audio_option": "Audio",
    "related_content.invalid_url_error": "Format da URL betg valaivel. Per plaschair endatar URL valaivla.",
    "related_content.label": "Cuntegn parentà",
    "related_content.learn_more": "Savair dapli davart quest tema",
    "related_content.retrieve_article_error": "Infurmaziuns da l'artitgel na pon betg vegnir dumandadas giu. Per plaschair controllar la URL ed empruvar anc ina giada.",
    "related_content.show_more_button": "Mussar dapli",
    "related_content.story_format_label": "Format da l'artitgel",
    "related_content.story_url_label": "URL da l'artitgel",
    "related_content.url_placeholder": "https://www.exemple.com",
    "related_content.video_option": "Video",
    "related_conversations.add_hint": "Agiuntar fin a quatter spazis.",
    "related_conversations.add_spaces_button": "Agiuntar spazis",
    "related_conversations.limit_reached_error": "Quest spazi ha gia quatter spazis colligads tschernids. Allontanai in avant che agiuntar in auter.",
    "related_conversations.next_button": "Vinavant",
    "related_conversations.no_spaces_available": "Nagins spazis disponibel",
    "related_conversations.no_spaces_found": "Chattà nagins spazis",
    "related_conversations.participant_count": "{count} {noun}",
    "related_conversations.participant_plural": "participant:as",
    "related_conversations.participant_singular": "participant:a",
    "related_conversations.previous_button": "Enavos",
    "related_conversations.search_placeholder": "Tschertgar",
    "related_conversations.title": "Conversaziuns parentadas",
    "representing_perspectives_template.description": "Dumondai ils utilisaders da respunder a Vossa dumonda ord ina tscherta perspectiva.",
    "representing_perspectives_template.description_1": "Tscherni **3-5 puncts da vista** concrets, dals quals Vus vulais contribuziuns (p. ex. „️🏖️ pensiunà“, „📦 nov vaschin“, „🍼 genitur che lavura“ euv.)",
    "representing_perspectives_template.description_2": "Evitai puncts da vista basads sin la demografia (p. ex. „urban“, „cun entradas bassas“, „dunna“ e.u.v.) che pudessan manar a stereotips",
    "representing_perspectives_template.description_3": "Evitai d'attribuir als puncts da vista tschertas persvasiuns (p.ex. „persuna cun tenuta conservativa“ u „adherents“ e „adversaris“)",
    "representing_perspectives_template.description_4": "Tscherni per mintga punct da vista in emoji",
    "representing_perspectives_template.description_5": "Separar ils puncts da vista cun ina nova lingia.",
    "representing_perspectives_template.form_field_label": "Puncts da vista",
    "representing_perspectives_template.helper_label": "Definir puncts da vista",
    "representing_perspectives_template.label": "Preschentar puncts da vista",
    "representing_perspectives_template.placeholder": "Scrivai 3-5 puncts da vista…",
    "roles.analyst": "Analist",
    "roles.developer": "Developer",
    "roles.editor": "Editur",
    "roles.editorial": "Redacziun",
    "roles.moderator": "Moderatur",
    "roles.observer": "Observatur",
    "roles.owner": "Owner",
    "roles.super_moderator": "Super-Moderatur",
    "roles.unknown": "Betg enconuschent",
    "satisfaction_survey_popover.question": "Quant cuntents essas Vus cun questa plattafurma da conversaziun?",
    "satisfaction_survey_popover.satisfied_label": "Fitg cuntent",
    "satisfaction_survey_popover.unsatisfied_label": "Fitg malcuntent",
    "saving": "Vid arcunar…",
    "search.no_members_found": "Betg chattà commemb:ras",
    "search.placeholder": "Vid tschertgar…",
    "settings.add_feature_button": "Agiuntar ina funcziun",
    "settings.add_format_button": "Agiuntar in format",
    "settings.add_to_organization_button": "Agiuntar a l'organisaziun",
    "settings.added_button": "Agiuntà",
    "settings.added_format_button": "Agiuntà",
    "settings.additional_features_heading": "Funcziuns supplementaras",
    "settings.ai_and_manual_moderation_description": "Pretender che tut las contribuziuns da las utilisad:ras passan l'IA e la controlla manuala avant la publicaziun.",
    "settings.ai_pre_moderation_description": "Utilisar l'IA per garantir che contribuziuns da las utilisad:ras correspundan a las directivas da la community avant la publicaziun.",
    "settings.ai_pre_moderation_with_post_anyway_description": "Permetter a las utilisa:dras da publitgar contribuziuns che l'IA giuditgescha da bassa qualitad ma betg privlus, ed als posiziunescha pli bass en il feed.",
    "settings.audience_input_description": "Rimnar dumondas, testimonis ed istorgias da las utilisad:ras. Quai po crear engaschament pli varià.",
    "settings.audience_input_label": "Input dal public",
    "settings.blocklist_description": "Blocai pleds specifics da tut las contribuziuns da las utilisad:ras.",
    "settings.blocklist_label": "Glisch da bloc",
    "settings.channels_description": "Organisar spazis en channels, uschia che las squadras redacziunalas e da moderaziun pon sa concentrar sin cuntegns relevants.",
    "settings.channels_label": "Channels",
    "settings.comment_slider_description": "Laschar respunder las utilisad:ras sin in spectrum (p.ex. da 'insumma betg' fin a 'dal tuttafatg')",
    "settings.comment_slider_label": "Comment slider",
    "settings.conversation_home": "Chasa da conversaziuns",
    "settings.conversation_home_description": "Pagina publica che mussa tut las conversaziuns activas e serradas dal silo",
    "settings.dialogue_description": "Laschai respunder las utilisad:ras cun in simpel 'Gea' e 'Na'",
    "settings.dialogue_label": "Dialog",
    "settings.heading": "Configuraziun {psiBrandName}",
    "settings.labs_description": "Formats prosocials en stadi inizial da svilup, disponibels per experimentaziun. Las funcziuns da Labs funcziunan, ma defaults standardisads mancan e la chaussa po sa midar cun il temp.",
    "settings.labs_heading": "Labs",
    "settings.manual_moderation_description": "Pretenda che tut ils posts da las utilisad:ras passan la controlla manuala avant la publicaziun; nagina IA per la moderaziun.",
    "settings.moderation_heading": "Moderaziun",
    "settings.premod_review_tab_description": "Agiuntescha in tab en il dashboard da moderaziun nua che moderaturs revesan mintga decisiun che l'IA ha prendì e registreschan sch'ella era correcta.",
    "settings.premod_review_tab_label": "Tab d'evaluaziun da l'IA",
    "settings.prosocial_formats_description": "Mintga spazi da discussiun è structurà tenor in format prosocial.",
    "settings.prosocial_formats_heading": "Formats prosocials",
    "settings.prosocial_ranking_description": "Mussar automaticamain ils commentaris ils pli infurmads e constructivs.",
    "settings.prosocial_ranking_label": "Rangaziun prosocial",
    "settings.representing_perspectives_description": "Laschar respunder las utilisad:ras ord in tschert punct da vista sin la dumonda.",
    "settings.representing_perspectives_label": "Preschentar puncts da vista",
    "settings.stories_description": "Colliads URLs d'istorgias publitgadas cun spazis da conversaziun, uschia che ina conversaziun integrada sa chargia sin las novitads che Vus tschernis. Pretenda ina configuraziun supplementara dal sviluppader.",
    "settings.stories_label": "Istorgias",
    "settings.titled_writers_description": "Mussar in label tar comemb:ras verifitgadas da Voss'organisaziun cura ch'el:las scrivan commentaris u respostas.",
    "settings.titled_writers_label": "Labels per autur:as",
    "settings.video_voting_description": "Mussar dumondas sur cuntegns da video.",
    "settings.video_voting_label": "Votaziun da video",
    "simple_ranking.most_reactions": "Las pli bleras reacziuns",
    "simple_ranking.newest": "Ils pli novs",
    "single_response_help.same_question_title": "Medema dumonda, nov artitgel?",
    "single_response_help.update_response_label": "Actualisai Vossa resposta precedenta cun novas invistas",
    "slider_with_stop_points.aria_label": "Duvrar la frizza sanestra dretga u ensi ed engiu per midar il slider",
    "sort.all": "Tuts",
    "sort.ascending": "A-Z",
    "sort.descending": "Z-A",
    "sort.most_recent": "Ils pli novs",
    "sort.top": "Top",
    "sort.top_voted": "Las pli bleras vuschs",
    "sort_button.aria_label": "Ordinar tenor {text}",
    "sort_menu.sort_by_header": "Zavrar tenor",
    "sorting.most_recent": "Ils pli novs",
    "sorting.oldest": "Ils pli vegls",
    "space.detail.id": "ID:",
    "space.detail.linkes.stories": "Artitgels colliads:",
    "space.detail.posts": "Contribuziuns:",
    "space.table.demo.name": "Num",
    "space.table.demo.responses": "Contribuziuns",
    "space.table.search": "Tschertga",
    "spaces.column_actions": "Acziuns",
    "spaces.column_comments": "Commentaris",
    "spaces.column_created": "Creà",
    "spaces.column_creationDate": "Creà",
    "spaces.column_format": "Format",
    "spaces.column_name": "Num",
    "spaces.column_needs_review": "Sto vegnir controllà",
    "spaces.column_notification_follow": "Suandar",
    "spaces.column_notification_following": "Suandant",
    "spaces.column_notifications": "Notificaziuns",
    "spaces.column_responses": "Contribuziuns",
    "spaces.column_status": "Status",
    "spaces.draft_created": "Spazi da sboz creà",
    "spaces.draft_not_created": "Errur: spazi da sboz betg creà",
    "spaces.filter_active": "Activ",
    "spaces.filter_closed": "Serrà",
    "spaces.filter_draft": "Sboz",
    "spaces.filter_heated": "Stgaudà",
    "spaces.filter_needs_review": "Sto vegnir controllà",
    "spaces.format_required_label": "Format prosocial (obligatoric)",
    "spaces.kickstart_conversation_tip": "Lantschar quest discurs cun agiuntar almain trais commentaris.",
    "spaces.new_button": "Nov spazi",
    "spaces.new_space_title": "Nov spazi",
    "spaces.no_spaces_found": "Chattà nagins spazis",
    "spaces.no_spaces_yet": "Anc nagins spazis",
    "spaces.no_templates_message": "Nagins musters disponibels",
    "spaces.prompt_help_avoid": "Evitar:",
    "spaces.prompt_help_avoid_1": "Dumondas suggestivas",
    "spaces.prompt_help_avoid_2": "Temas puramain teoretics",
    "spaces.prompt_help_good_prompts": "Buns appels èn:",
    "spaces.prompt_help_tip_1": "A temp, specific, culturalmain relevant",
    "spaces.prompt_help_tip_2": "Avert per debatta e discussiun",
    "spaces.prompt_help_tip_3": "Cler ed avert, ma betg abstract",
    "spaces.prompt_help_title": "Duvrais Vus agid per scriver?",
    "spaces.prompt_label": "Prompt",
    "spaces.prompt_placeholder": "Scriver ina dumonda u in prompt da discussiun…",
    "spaces.status_active": "Activ",
    "spaces.status_closed": "Serrà",
    "spaces.status_draft": "Sboz",
    "spaces.still_need_help": "Anc duvrà agid?",
    "spaces.tab_label": "Spazis",
    "spaces.title": "Spazis",
    "spaces.visit_playbook": "Visita il Playbook PSI",
    "srg.profile.error_name_invalid": "Nums d'utilisadr:as dastgan mo consister da lettras, cifras, spazis e stritgs",
    "standalone_question.participant": "participant:a",
    "standalone_question.participants": "participant:as",
    "status.creation_successful": "Creà",
    "status.edit_successful": "Edità",
    "status.reload_to_see_effect": "Rechargia l'artitgel per vesair l'effect",
    "status.reported": "Rapportà",
    "story_dash.action_attach_spaces": "Colliar spazis",
    "story_dash.action_edit_spaces": "Editar spazis colliads",
    "story_dash.action_remove": "Allontanar",
    "story_dash.action_view": "Mussar l'artitgel",
    "story_dash.actions_column": "Acziuns",
    "story_dash.add_story_button": "Agiuntar artitgel",
    "story_dash.add_title": "Agiuntar artitgel",
    "story_dash.attach_space_label": "Spazis",
    "story_dash.attach_space_modal_heading": "Colliar spazis",
    "story_dash.attach_spaces": "Colliar spazis",
    "story_dash.attach_spaces_button": "Colliar spazis",
    "story_dash.attach_spaces_description": "Colliar spazi(s) existent(s) cun quest artitgel.",
    "story_dash.attach_spaces_modal_description": "Colliar il sectur (s) existent (s) cun questa story.",
    "story_dash.attached_spaces_more": "+{count} pli bler:as",
    "story_dash.cancel_button": "Interrumper",
    "story_dash.connected_space_column": "Spazis colliads",
    "story_dash.create_button": "Agiuntar artitgel",
    "story_dash.date_column": "Publitgà",
    "story_dash.domains_column": "Domenas",
    "story_dash.filter_all": "Tuts",
    "story_dash.invalid_url_error": "Per plaschair endatar URL valaivla",
    "story_dash.name_column": "Num",
    "story_dash.no_matches": "Nagin artitgel correspunda a Vossa tschertga.",
    "story_dash.no_stories": "Anc nagins artitgels. Agiunta in artitgel per cumenzar.",
    "story_dash.remove_confirm_button": "Allontanar",
    "story_dash.remove_modal_description": "Questa acziun na po betg vegnir revocada. Tut ils spazis colliads vegnan separads.",
    "story_dash.remove_modal_description_2": "Vus pudais adina puspè agiuntar quest artitgel e colliar spazis cun el.",
    "story_dash.remove_modal_heading": "Allontanar quest artitgel?",
    "story_dash.save_button": "Arcunar",
    "story_dash.search": "Tschertgar…",
    "story_dash.search_placeholder": "Tschertgar…",
    "story_dash.spaces_updated_toast": "Spazis actualisads",
    "story_dash.story_added_toast": "Artitgel agiuntà",
    "story_dash.story_removed_toast": "Artitgel è allontanà spazis èn decolliads",
    "story_dash.story_url_label": "URL da l'artitgel",
    "story_dash.tab": "Artitgels",
    "story_dash.table_heading": "Artitgels",
    "story_dash.url_description": "Agiunta in artitgel, in video u autras medias.",
    "story_dash.url_placeholder": "www.exempel.com",
    "strongly_agree": "Dal tuttafatg d'accord",
    "strongly_disagree": "Dal tuttafatg cunter",
    "survey.feedback_help": "Voss feedback ans gida da megliurar Vossa experientscha.",
    "survey.strongly_agree": "Dal tuttafatg d'accord",
    "survey.strongly_disagree": "Dal tuttafatg cunter",
    "survey.tell_us_experience": "Ans raquintai da Vossas experientschas",
    "survey.thank_you": "Grazia fitg che Vus avais partì cun nus Vossas experientschas!",
    "suspension.block_user_confirm": "Bloccar {userName}?",
    "suspension.block_user_description": "L'utilisader na po betg s'annunziar en il spazi da discussiun.",
    "suspension.moderator_blocked_you": "In moderatur t'ha bloccà",
    "suspension.moderator_unblocked_you": "In moderatur ha sbloccà tai",
    "suspension.moderator_unwarned_you": "In moderatur ha revocà l'admoniziun",
    "suspension.moderator_warned_you": "In moderatur t'ha admonì",
    "suspension.unblock_user_confirm": "Debloccar {userName}?",
    "suspension.unblock_user_description": "L'utilisader po puspè participar en il spazi da discussiun.",
    "table_grid.empty": "Qua na datti anc nagut",
    "tag.beta": "Beta-Test",
    "template.perspectives_description": "Separar puncts da vista cun ina nova lingia.",
    "template.perspectives_label": "Puncts da vista",
    "text.character_count": "{count}/{max} segns",
    "text.character_count_max": "{count}/{max} segns max",
    "text.character_count_min": "{min} segns min",
    "text.character_count_over_max": "{count}/{max} segns max",
    "text.character_count_progress_min": "{count}/{min} segns min",
    "tile.experimental_label": "Beta",
    "tile.outdated_label": "Obsolet",
    "time.format": "{time}",
    "upvote.aria_label": "Votar en favur",
    "upvote.count": "{count}",
    "usability_survey.easy_to_use_question": "Questa plattafurma da discussiun è simpla d'utilisar.",
    "usability_survey.meets_needs_question": "Questa plattafurma satisfa mes basegns",
    "user.member": "Commemb:ra",
    "user_info.account_button": "Account",
    "user_info.admin": "Administratur:a",
    "user_info.developer_features": "Funcziunalitat per devs",
    "user_info.faqs": "FAQ",
    "user_info.log_in_button": "As colliai (log in)",
    "user_info.log_out_button": "Sortir",
    "user_info.profile_button": "Profil",
    "user_info.profile_menu_aria_label": "Menu dal profil da {name}",
    "video_link.go_to_video": "Guardar il video",
    "video_voting.community_average": "Media da la communitad",
    "video_voting.continue_button": "Continuar",
    "video_voting.create_new_voting": "Crear ina nova votaziun",
    "video_voting.current_session_state": "Object dal status da la session actuala",
    "video_voting.deactivate_all": "Vus al pudais deactivar per tut ils videos.",
    "video_voting.discourse": "Discuors",
    "video_voting.edit_title": "Editar votaziun da video",
    "video_voting.enable_all_videos": "Activar la votaziun per tut ils videos",
    "video_voting.enable_voting": "Votaziun activa",
    "video_voting.intro_text": "Quest video cuntegna dumondas da l'audienza en las qualas ti pos participar. Ti pos votar anonimamente, skippar dumondas singulas u deactivar questa funcziun. En il",
    "video_voting.join_discussion": "Faschai part a la discussiun",
    "video_voting.manage_voting_admin": "Administrar votaziuns (admin)",
    "video_voting.no_data_available": "Naginas datas da votaziun disponiblas",
    "video_voting.no_main_screen": "Betg definì in monitur principal per votar cun video.",
    "video_voting.no_question_overlay": "Mussà nagin overlay da dumondas",
    "video_voting.no_space_selected": "Tscherna in spazi per questa votaziun avant che memorisar.",
    "video_voting.not_logged_in_text": "Vus stuais esser connect:ada per pudair utilisar questa funcziun.\n Il video vegn mussà sco usità e Vus na vesais naginas votaziuns.\n **Cliccai qua per As colliar (login)**.",
    "video_voting.preview_admin": "Prevista votaziun da video (admin)",
    "video_voting.select_voting_for_article": "Tscherni ina votaziun per quest artitgel",
    "video_voting.settings": "Configuraziun",
    "video_voting.start_video": "Start dal video",
    "video_voting.template_missing": "Il muster da la votaziun da video manca",
    "video_voting.time": "Temp:",
    "video_voting.title": "Votaziun da video",
    "video_voting.vote_anonymously": "Votar anonim",
    "video_voting.votings_tab": "Votaziuns",
    "video_voting.waiting_for_video": "Spetgar sin ch'il video chargia!",
    "video_voting.you": "Vus",
    "videoplayer_demo.pause": "PAUSA",
    "videoplayer_demo.play": "PLAY",
    "videoplayer_demo.seek_60": "SIGLIR A 60 SECUNDAS",
    "videovoting.select_chapter": "Tscherni in chapitel",
    "videovoting.select_existing_voting": "Tscherni ina votaziun da video existenta",
    "videovoting.select_question": "Tscherni ina dumonda",
    "visibility.only_visible_to_admins": "Visibel mo per admins",
    "vote.delete_button": "Stizzar",
    "vote.delete_modal_heading": "Essas Vus segir:a che Vus vulais stizzar Vossa vusch?",
    "vote.delete_modal_warning": "Questa acziun na po betg vegnir revocada.",
    "voting.no": "Na",
    "voting.yes": "Gea",
    "zdf_admin.votings": "Votaziuns",
    "zdf_article.manage_teaser_positions": "Administrar las posiziuns da teaser",
    "zdf_article.pick_positions": "Tscherna fin a 2 posiziuns",
    "zdf_article.teaser_position_last_paragraph": "Suenter l'ultim paragraf en il text principal",
    "zdf_article.teaser_position_second_paragraph": "Suenter il segund paragraf en il text principal",
    "zdf_article.teaser_position_second_subheading": "Sur il segund sut-titel en il text principal",
    "zdf_channels.add_channel_title": "Agiuntar canal",
    "zdf_channels.add_members": "Agiuntar commembers",
    "zdf_channels.channel_name_error": "Endatescha in num da chanèl.",
    "zdf_channels.channel_name_label": "Num dal canal",
    "zdf_channels.default_channel_access": "Tuts utilisaders admins han access al canal standard.",
    "zdf_channels.default_channel_explanation": "Tut ils utilisaders admin han access al chanal da standard. \n \n Novas dumondas che n'èn betg attribuidas ad in chanal specific vegnan attribuidas al chanal da standard. \n \n I po dar mo in chanal da standard.",
    "zdf_channels.delete_channel_title": "Stizzar canal",
    "zdf_channels.delete_confirmation": "Dovra quest canal propi vegnir stizzà?",
    "zdf_channels.edit_channel_title": "Modifitgar canal",
    "zdf_channels.image_url_error": "Endatescha in URL cumplet per il maletg, che cumenza cun https://.",
    "zdf_channels.image_url_label": "URL da l'illustraziun",
    "zdf_channels.member_search_field": "Champ da tschertgar commembers",
    "zdf_channels.members_label": "Commembers",
    "zdf_channels.super_moderator_access": "Tuts super-moderaturs han access a quest canal.",
    "zdf_channels.use_as_default": "Utilisar sco canal predefinit",
    "zdf_moddashboard.ai_explanation": "Explicaziun da l'AI",
    "zdf_videovoting.no_session": "**Betg inizialisà ina sesida**",
    "zdf_videovoting.poll_type": "Enquista",
    "zdf_videovoting.slider_type": "Slider",
    "zdf_videovoting_editor.add_chapter": "Agiuntar chapitel",
    "zdf_videovoting_editor.add_option": "Agiuntar opziun",
    "zdf_videovoting_editor.add_predetermined_answer": "Agiuntar ina resposta predeterminada",
    "zdf_videovoting_editor.add_question": "Agiuntar dumonda",
    "zdf_videovoting_editor.answer_label": "Etichetta da resposta",
    "zdf_videovoting_editor.answer_value": "Valur da resposta",
    "zdf_videovoting_editor.assign_chapter": "Attribuir in chapitel",
    "zdf_videovoting_editor.assign_space": "Attribuir in spazi",
    "zdf_videovoting_editor.chapters": "Chapitel:",
    "zdf_videovoting_editor.layout": "Layout:",
    "zdf_videovoting_editor.maximum_value": "Maximum",
    "zdf_videovoting_editor.minimum_value": "Minimum",
    "zdf_videovoting_editor.name": "Num",
    "zdf_videovoting_editor.open_preview": "Avrir la prevista (debug)",
    "zdf_videovoting_editor.options": "Opziuns",
    "zdf_videovoting_editor.prefill_data": "Emplenir ordavant cun datas da votaziuns existentas",
    "zdf_videovoting_editor.question_name": "Num da la dumonda",
    "zdf_videovoting_editor.question_type": "Gener da dumonda",
    "zdf_videovoting_editor.questions": "Dumondas:",
    "zdf_videovoting_editor.remove_chapter": "Allontanar chapitel",
    "zdf_videovoting_editor.selected_chapter": "Chapitel tschernì:",
    "zdf_videovoting_editor.selected_space": "Spazi tschernì:",
    "zdf_videovoting_editor.slider_answers": "Respostas dal slider",
    "zdf_videovoting_editor.slider_options": "Opziuns dal slider",
    "zdf_videovoting_editor.stops_video": "Stop video",
    "zdf_videovoting_editor.timestamp": "Timestamp",
    "zdf_videovoting_editor.unit": "Unitad",
    "zdf_videovoting_editor.video_info": "Info dal video:",
    "zdf_videovoting_editor.voting_title": "Titel da la votaziun",
    "{count} {noun}": "{count} {noun}"
}
